import { useContext, useState } from "react";
import Context from "../../../Context.js";
import { useTranslation } from "react-i18next";
import AnimatedNavHorizontal from "../loggedOut/landingPage/loggedOutHomeForApp/AnimatedNavHorizontal.js";
import { BiHome } from "react-icons/bi";
import { RiFilterLine } from "react-icons/ri";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { IoOptions } from "react-icons/io5";

export default function NavBarMobile() {
  const { loggedInUser, themeState } = useContext(Context);
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  if (!loggedInUser) return null;

  let options = [
    {
      value: "HOME",
      label: "Home",
      icon: <MdOutlineSpaceDashboard />,
      link: "/",
    },
    {
      value: "NOMENCLATURE",
      label: "Nomenclature",
      icon: <RiFilterLine />,
      link: "/nomenclature",
    },
    // {
    //   value: "CHAT",
    //   label: "Chat",
    //   icon: themeState.chat,
    //   link: "/chat",
    // },
    {
      value: "OPTIONS",
      label: "Options",
      icon: <IoOptions />,
      link: "/options",
    },
  ];

  return (
    <AnimatedNavHorizontal
      tabs={options}
      activeIndex={tabIndex}
      setActiveIndex={setTabIndex}
    />
  );
}
